import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { ClientCreditNoteDTO } from '../../interface/credit-notes.interface';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FilterPagination } from '../../interface/company-client.interface';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-client-credit-notes-table',
  templateUrl: './client-credit-notes-table.component.html',
  styleUrls: ['./client-credit-notes-table.component.scss']
})
export class ClientCreditNotesTableComponent implements OnInit, OnChanges {

  @ViewChild(MatPaginator, {static: true})
  paginator: MatPaginator;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @Input()
  public pagedResult: PageResult<ClientCreditNoteDTO>;

  @Output()
  changePagination = new EventEmitter<FilterPagination>;

  @Output()
  changeSortOrder = new EventEmitter<string>;

  public dataSource: MatTableDataSource<ClientCreditNoteDTO> = new MatTableDataSource<ClientCreditNoteDTO>;
  public displayColumns = [
    'folio',
    'clientRut',
    'clientName',
    'fechaDocto',
    'montoExento',
    'montoNeto',
    'montoIVA',
    'montoTotal'

  ];

  constructor(){
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const {sortColumn, sortDirection} = this.pagedResult
    this.dataSource.data = this.pagedResult?.results ??[];
    this.paginator.length = this.pagedResult?.totalRows ?? 0;
    this.paginator.pageIndex = this.pagedResult?.currentPage -1 ?? 0;
    this.paginator.pageSize = this.pagedResult?.pageSize ?? 10;
    if(sortColumn && sortDirection)
      this.setSorting(sortColumn, sortDirection);
  }

  setSorting(sortColumn: string, sortDirection: string) {
    this.sort.active = sortColumn.charAt(0).toLowerCase() + sortColumn.slice(1);
    this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
  }

  changePaginationTable(event: PageEvent){
    const pagination: FilterPagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.changePagination.emit(pagination);
  }

  /**
   * Recibir evento de cambio de ordenamiento de tabla de notas de credito
   * @param sortState cambios en ordenamiento de tabla
   * @returns 
   */
  sortTableChange(sortState: Sort) {
    if(sortState.direction === ''){
      this.changeSortOrder.emit(null);
      return;
    }
    const sortCol = sortState.active.charAt(0).toUpperCase() + sortState.active.slice(1);
    const sortConf = `${sortCol}_${sortState.direction}`;
    this.changeSortOrder.emit(sortConf);
  }
}
